{
  "valid": "Ważny"
}
